import React from 'react';
import { useHistory } from "react-router-dom";


const NotAuthorized = () => {
    const history = useHistory();

  return (
    <div className="not-authorized-container">
      <h1>403 - Not Authorized</h1>
      <p>You do not have permission to access this page.</p>
      <button onClick={() => history.goBack()}>Go back to Home</button>
    </div>
  );
};

export default NotAuthorized;
